import { Component, EventEmitter, Input, Output } from "@angular/core";

import { User, Notification, NotificationListConfig } from "../../../../models";
import { NotificationListResult } from "../../../../interfaces";
import { NotificationService } from "../../../../services";

@Component({
  selector: "general-notification-list",
  templateUrl: "./general-notification-list.component.html",
  styleUrls: [
    "./general-notification-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class GeneralNotificationListComponent {
  constructor(private notificationService: NotificationService) {}

  private query: NotificationListConfig;
  public results: Notification[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalCount: number;

  @Output() confirmAlert = new EventEmitter<any>();
  @Input() limit: number;
  @Input() currentUser: User;
  @Input()
  set config(config: NotificationListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public updateNotifications() {
    this.runQuery();
  }

  public fetchUserNotifications() {
    this.notificationService
      .findMany(this.currentUser.username, this.query)
      .subscribe((data: NotificationListResult) => {
        this.results = data.notifications;
        this.totalCount = data.notificationCount.total;
        this.totalPages = data.pages.total;
        this.confirmAlert.emit(data.notifications.length > 0);
        this.loading = false;
      });
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.limit = this.limit;
      this.query.offset = this.limit * (this.currentPage - 1);
    }

    this.fetchUserNotifications();
    window.scroll(0, 0);
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }
}
